import { coercedDate } from '../../../utils/coerced-date';
import { vehicleAssetSchema } from '../../accounts/schemas/vehicle-asset.schema';
import { z } from 'zod/v4';

export const vehicleSchema = z.object({
  id: z.number(),
  name: z.string(),
  vehicleId: z.string(),
  modifiedOn: coercedDate,
  vehicleGroups: z
    .array(
      z.object({
        vehicleGroupId: z.number().min(0),
        vehicleGroupName: z.string().min(1),
      })
    )
    .optional(),
  assets: z.array(vehicleAssetSchema).optional(),
});

export const vehicleImportSchema = vehicleSchema
  .pick({
    name: true,
    vehicleId: true,
  })
  .extend({
    Groups: z.array(z.object({ vehicleGroupName: z.string() })).optional(),
  });

export type Vehicle = z.infer<typeof vehicleSchema>;

export type VehicleImport = z.infer<typeof vehicleImportSchema>;
